module.exports = __webpack_public_path__ + "assets/Arrow-accent-right.0a61966c.svg";